/**
 * X6 при embedding встраивает связь в общего предка source/target. Тогда при translate родителя
 * eachChild вызывает edge.translate — и плагин Selection снова сдвигает те же рёбра (vertices),
 * из‑за чего bendpoints уезжают в 2 раза быстрее группы. Держим рёбра без родителя-ноды.
 *
 * Массовое снятие встраивания после bulk-рендера делается синхронно в renderView (до patch-sync).
 * Здесь только реакция на новые/перепривязанные рёбра в рантайме.
 */
import {detachEdgeFromNodeParent} from '../modelerX6/edgeKeepRoot';

export default {
	init(_modeler, context) {
		const {graph} = context;

		const scheduleDetach = args => {
			const edge = args?.edge ?? args?.cell;
			queueMicrotask(() => detachEdgeFromNodeParent(edge));
		};

		graph.on('edge:added', scheduleDetach);
		graph.on('edge:change:parent', scheduleDetach);

		return () => {
			graph.off('edge:added', scheduleDetach);
			graph.off('edge:change:parent', scheduleDetach);
		};
	},
};
